module.exports = "/assets/images/pencil_7359b1.svg";